import React from 'react';
import Link from "next/link";

const RelatedResult = ({data}: { data: any }) => {

    const relatedResults = data?.searches;

    return (

        <>
            {relatedResults?.length > 0 ? (
                <div>
                    <h4 className={"text-base"}>مرتبط ترین ها</h4>
                    <div className={"grid grid-cols-2 gap-4 mt-2"}>
                        {relatedResults?.map((item: any, index: number) => (
                            <Link target={"_blank"} key={index}
                                  className={"text-sm hover:text-orange-primary transition-all"}
                                  href={`/search?search=${item?.keyword}`}>{item?.keyword}</Link>
                        ))}
                    </div>
                </div>

            ) : <div className={"flex flex-col min-h-24 items-center justify-center"}>محصولی یافت نشد</div>}
        </>
    );
};

export default RelatedResult;